import { createContext, useContext } from 'react';

import { useQuery } from '@tanstack/react-query';

import { noop } from '@utils/browser';

import { UnsplashResponse } from './types';

const UnsplashApiContext = createContext<UnsplashContextProps>({
  loadUnsplashSearch: noop as any,
  triggerUnsplashDownload: noop as any,
});

export const useUnsplashApi = () => {
  return useContext(UnsplashApiContext);
};

type UnsplashContextProps = {
  loadUnsplashSearch(props: LoadUnsplashSearchProps): Promise<UnsplashResponse>;
  triggerUnsplashDownload(props: TriggerUnsplashDownloadProps): Promise<void>;
};

export const UnsplashProvider: React.FC<UnsplashContextProps> = ({ children, ...value }) => {
  return <UnsplashApiContext.Provider value={value} children={children} />;
};

const DEFAULT_PAGE_SIZE = 6;

export type LoadUnsplashSearchProps = {
  search: string;
  page: number;
  pageSize?: number;
};

export const useUnsplashSearchQuery = ({
  search,
  pageSize = DEFAULT_PAGE_SIZE,
  ...rest
}: LoadUnsplashSearchProps) => {
  const { loadUnsplashSearch } = useUnsplashApi();

  return useQuery({
    queryKey: ['unsplash-search', search, rest.page, pageSize],
    queryFn: () =>
      loadUnsplashSearch({
        search,
        pageSize,
        ...rest,
      }),
  });
};

export type TriggerUnsplashDownloadProps = {
  ixid: string;
  slug: string;
};
